/**
 * mwApp.auth module <br>
 * Authentication, login, restore lost password
 *
 * @namespace mwApp/auth
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc config
 * @name mwApp/auth.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * controller {@link mwApp/auth.controller:LoginCtrl}
     * @name /login
     * @memberof mwApp/auth.config:ConfigRoutes
     */
    .state('login', {
      url: '/login?{go:any}',
      views: {
        '': {
          templateUrl: 'components/auth/views/login.html',
          controller: 'LoginCtrl as vm'
        },
        maintenance: {
          templateUrl: 'components/common/views/maintenance.html',
          controller: 'MaintenanceCtrl as vm'
        }
      },
      onEnter: /* @ngInject */ function ($rootScope, $state) {
        if ($rootScope.authenticated) {
          $state.go('app.dashboard')
        }
      }
    })

    /**
     * controller {@link mwApp/auth.controller:SetplexLoginCtrl}
     * @name /setplex-login
     * @memberof mwApp/auth.config:ConfigRoutes
     */
    .state('setplex-login', {
      url: '/setplex-login?{go:any}',
      views: {
        '': {
          templateUrl: 'components/auth/views/setplex-login.html',
          controller: 'SetplexLoginCtrl as vm'
        },
        maintenance: {
          templateUrl: 'components/common/views/maintenance.html',
          controller: 'MaintenanceCtrl as vm'
        }
      },
      onEnter: /* @ngInject */ function ($rootScope, $state) {
        if ($rootScope.authenticated) {
          $state.go('app.dashboard')
        }
      }
    })

    /**
     * controller {@link mwApp/auth.controller:LostPasswordCtrl}
     * @name /lostpassword
     * @memberof mwApp/auth.config:ConfigRoutes
     */
    .state('lostpassword', {
      url: '/lostpassword',
      views: {
        '': {
          templateUrl: 'components/auth/views/lostpassword.html',
          controller: 'LostPasswordCtrl as vm'
        },
        maintenance: {
          templateUrl: 'components/common/views/maintenance.html',
          controller: 'MaintenanceCtrl as vm'
        }
      },
      params: {
        tokenError: false
      }
    })

    /**
     * controller {@link mwApp/auth.controller:ResetPasswordCtrl}
     * @name /passwordresetconfirm
     * @memberof mwApp/auth.config:ConfigRoutes
     */
    .state('passwordresetconfirm', {
      url: '/passwordresetconfirm/:token',
      views: {
        '': {
          templateUrl: 'components/auth/views/passwordreset.html',
          controller: 'PasswordResetCtrl as vm'
        },
        maintenance: {
          templateUrl: 'components/common/views/maintenance.html',
          controller: 'MaintenanceCtrl as vm'
        }
      }
    })
}
